// extracted by mini-css-extract-plugin
export default {"wrapper":"IVLa1","closeState":"pyBaK","iconWrap":"G2RhZ","btnText":"ZJJLk","icon":"QU1qg"};